// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Whitepaper_wrapper__OP7CM","flame-wrapper":"Whitepaper_flame-wrapper__NdX6j"};